(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["petgraf-collection"]) return;
  try {
    
(()=>{const url=new URL(location.href);const next=document.querySelector('[data-collection-next]');if(!next)return;let loading=false;const load=async()=>{if(loading||!next.href)return;loading=true;next.textContent='Carregando materiais…';try{const response=await fetch(next.href);if(!response.ok)throw Error();const doc=new DOMParser().parseFromString(await response.text(),'text/html');const cards=doc.querySelectorAll('#CollectionProducts>.pg-card');if(!cards.length)throw Error();cards.forEach(card=>document.querySelector('#CollectionProducts').append(card));const link=doc.querySelector('[data-collection-next]');if(link){next.href=link.href;next.textContent='Carregar mais materiais';}else{next.remove();}}catch{next.textContent='Tentar carregar novamente';}finally{loading=false;}};/* Sem carga automática ao rolar: o rodapé precisa ser alcançável. O próximo bloco só vem pelo botão. */next.addEventListener('click',event=>{event.preventDefault();load();});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petgraf-footer"]) return;
  try {
    
if(!customElements.get('pg-footer-disclosures'))customElements.define('pg-footer-disclosures',class extends HTMLElement{
 connectedCallback(){this.media=matchMedia('(max-width:767px)');this.groups=[...this.querySelectorAll('.pg-footer-group')];this.sync=()=>this.groups.forEach(group=>group.open=!this.media.matches);this.sync();this.media.addEventListener('change',this.sync);
  this.guard=event=>{if(this.media.matches)return;const summary=event.target.closest('summary');if(summary&&summary.parentElement?.classList.contains('pg-footer-group'))event.preventDefault();};
  this.addEventListener('click',this.guard);}
 disconnectedCallback(){this.media?.removeEventListener('change',this.sync);this.removeEventListener('click',this.guard);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petgraf-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pg-drag-scroll'))customElements.define('pg-drag-scroll',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const {signal}=this.abort,track=this.querySelector('[data-drag-track],nav');if(!track)return;
  let drag=null,suppressUntil=0;
  track.addEventListener('pointerdown',e=>{
   if(e.pointerType==='touch'||e.button!==0||track.scrollWidth<=track.clientWidth+1)return;
   drag={id:e.pointerId,x:e.clientX,y:e.clientY,left:track.scrollLeft,moved:false};
  },{signal});
  window.addEventListener('pointermove',e=>{
   if(!drag||e.pointerId!==drag.id)return;
   const dx=e.clientX-drag.x,dy=e.clientY-drag.y;
   if(!drag.moved&&Math.abs(dy)>Math.abs(dx)&&Math.abs(dy)>6){drag=null;return;}
   if(!drag.moved&&Math.abs(dx)<6)return;
   drag.moved=true;track.dataset.dragging='true';
   if(!track.hasPointerCapture(e.pointerId))track.setPointerCapture(e.pointerId);
   e.preventDefault();track.scrollLeft=drag.left-dx;
  },{signal});
  const end=e=>{
   if(!drag||e.pointerId!==drag.id)return;
   const {id,moved}=drag;drag=null;if(moved)suppressUntil=performance.now()+400;
   delete track.dataset.dragging;if(track.hasPointerCapture(id))track.releasePointerCapture(id);
  };
  window.addEventListener('pointerup',end,{signal});window.addEventListener('pointercancel',end,{signal});track.addEventListener('lostpointercapture',end,{signal});
  track.addEventListener('click',e=>{if(e.detail!==0&&performance.now()<suppressUntil){e.preventDefault();e.stopImmediatePropagation();}},{capture:true,signal});
  track.addEventListener('dragstart',e=>e.preventDefault(),{signal});
  track.addEventListener('keydown',e=>{
   if(e.target!==track||track.scrollWidth<=track.clientWidth+1||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
   e.preventDefault();const left=e.key==='Home'?0:e.key==='End'?track.scrollWidth:track.scrollLeft+(e.key==='ArrowRight'?1:-1)*track.clientWidth*.88;
   track.scrollTo({left,behavior:'auto'});
  },{signal});
 }
 disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petgraf-page"]) return;
  try {
    
if(!customElements.get('pg-info-page'))customElements.define('pg-info-page',class extends HTMLElement{connectedCallback(){this.abort=new AbortController();for(const section of this.querySelectorAll('.pg-prose>section')){const heading=section.querySelector('h2');if(!heading)continue;const details=document.createElement('details'),summary=document.createElement('summary'),content=document.createElement('div');summary.textContent=heading.textContent;heading.remove();while(section.firstChild)content.append(section.firstChild);details.append(summary,content);section.append(details);}const openAnchor=()=>{let id;try{id=decodeURIComponent(location.hash.slice(1));}catch{return;}if(!id)return;const target=document.getElementById(id);if(this.contains(target)){const details=target.querySelector('details')||target.closest('details');if(details)details.open=true;requestAnimationFrame(()=>target.scrollIntoView({block:'start'}));}};window.addEventListener('hashchange',openAnchor,{signal:this.abort.signal});openAnchor();}disconnectedCallback(){this.abort?.abort();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petgraf-panels"]) return;
  try {
    
  (() => {
    const runtime = document.querySelector('[data-pg-runtime]');
    if (!runtime || window.petgrafPanelsReady) return;
    window.petgrafPanelsReady = true;
    document.documentElement.classList.add('pg-runtime-ready');
    const messages = runtime.dataset;
    const productDialog = runtime.querySelector('[data-product-dialog]');
    const searchDialog = runtime.querySelector('[data-search-dialog]');
    const cartDialog = runtime.querySelector('[data-cart-dialog]');
    const openers = new WeakMap();
    const requests = new WeakMap();
    let productLinks = [], productIndex = 0, cartBusy = false, additionPending = false, toastTimer;
    const panelBody = dialog => dialog.querySelector('[data-panel-content]');
    const parse = html => new DOMParser().parseFromString(html, 'text/html');
    const notify = message => { const node = runtime.querySelector('[data-pg-status]'); node.textContent = message; node.hidden = false; clearTimeout(toastTimer); toastTimer = setTimeout(() => { node.hidden = true; }, 4500); };
    function show(dialog, opener) {
      if (dialog.open) return;
      openers.set(dialog, opener || document.activeElement);
      dialog.showModal(); document.documentElement.classList.add('pg-panel-open');
      const anchor = dialog.querySelector('h2') || dialog;
      anchor.tabIndex = -1; anchor.focus({preventScroll:true});
    }
    function close(dialog) { if (dialog?.open) dialog.close(); }
    document.addEventListener('pg:open-dialog', event => show(event.detail.dialog,event.detail.opener));
    runtime.querySelectorAll('dialog').forEach(dialog => {
      dialog.addEventListener('close', () => {
        requests.get(dialog)?.abort();
        if (!runtime.querySelector('dialog[open]')) document.documentElement.classList.remove('pg-panel-open');
        const opener = openers.get(dialog); if (opener?.isConnected) opener.focus({preventScroll:true});
      });
      dialog.addEventListener('click', event => { if (event.target !== dialog) return; const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(dialog); });
    });
    async function section(url, id, selector, signal) {
      const target = new URL(url, location.origin); target.searchParams.set('section_id', id);
      const response = await fetch(target, {signal:signal || AbortSignal.timeout(30000)});
      if (!response.ok) throw new Error(messages.error);
      const result = parse(await response.text()).querySelector(selector);
      if (!result) throw new Error(messages.error);
      return result;
    }
    function loading(dialog) { const p = document.createElement('p'); p.className = 'pg-panel-message'; p.textContent = messages.loading; panelBody(dialog).replaceChildren(p); }
    function errorPanel(dialog, retry) { const box = document.createElement('div'); box.className = 'pg-panel-error'; const p = document.createElement('p'); p.textContent = messages.error; const button = document.createElement('button'); button.className = 'pg-button'; button.textContent = messages.retry; button.addEventListener('click', retry, {once:true}); box.append(p,button); panelBody(dialog).replaceChildren(box); }
    async function openProduct(url, opener, kitContext = false) {
      productDialog.toggleAttribute("data-kit-context",kitContext);
      productDialog.querySelector("[data-kit-return]").hidden=!kitContext;
      productDialog.querySelector(".pg-product-paging").hidden=kitContext;
      show(productDialog, opener); loading(productDialog);
      requests.get(productDialog)?.abort(); const controller = new AbortController(); requests.set(productDialog, controller);
      productDialog.querySelector('[data-full-product]').href = url;
      productDialog.querySelectorAll('[data-product-prev],[data-product-next]').forEach(button => { button.disabled = productLinks.length < 2; });
      try { const root = await section(url, 'petgraf-product', '[data-pg-product]', controller.signal); if (!controller.signal.aborted && productDialog.open) {
        if(kitContext){
          const selected=root.querySelector('[name=id]:checked')||root.querySelector('select[name=id]')?.selectedOptions[0];
          const label=document.createElement('p');label.className='pg-kit-selected';const quantity=selected?.dataset.quantityLabel||selected?.closest('label')?.querySelector('.pg-unit-long')?.textContent||selected?.textContent?.trim()||opener.closest('li').querySelector('.pg-unit-long')?.textContent||'';label.append('Neste kit: ');for(const [className,text] of [['pg-unit-long',quantity],['pg-unit-short',quantity.replace(/ unidades?\b/g,' un.')]]){const span=document.createElement('span');span.className=className;span.textContent=text;label.append(span);}
          const form=root.querySelector('form');form?.prepend(label);
          root.querySelectorAll('form input,form select,form button').forEach(control=>control.disabled=true);
          const back=document.createElement('button');back.type='button';back.className='pg-button';back.dataset.closeDialog='';back.textContent='Voltar ao kit';form?.append(back);back.disabled=false;
        }
        panelBody(productDialog).replaceChildren(root);
        updateLogoStates();
      } }
      catch (error) { if (error.name !== 'AbortError') errorPanel(productDialog, () => openProduct(url, opener, kitContext)); }
    }
    function nextProduct(delta) { if (productLinks.length < 2) return; productIndex = (productIndex + delta + productLinks.length) % productLinks.length; openProduct(productLinks[productIndex], openers.get(productDialog)); }
    function searchUrl(query) { const url = new URL(messages.search, location.origin); url.searchParams.set('type','product'); if(query.trim()) url.searchParams.set('q',query); return url; }
    function bindSearch(root) {
      root.querySelectorAll('[data-live-search]').forEach(form => {
        if (form.dataset.bound) return; form.dataset.bound = 'true';
        const input = form.elements.q, results = form.closest('[data-search-surface]').querySelector('[data-search-results]');
        let timer, controller, generation = 0;
        async function run() {
          controller?.abort(); controller = new AbortController(); const current = ++generation;
          results.setAttribute('aria-busy','true');
          try { const surface = await section(searchUrl(input.value), 'petgraf-search', '[data-search-results]', controller.signal); if (current === generation) results.replaceChildren(...surface.childNodes); }
          catch (error) { if (error.name !== 'AbortError' && current === generation) { const p = document.createElement('p'); p.textContent = messages.error; results.replaceChildren(p); } }
          finally { if(current === generation) results.removeAttribute('aria-busy'); }
        }
        input.addEventListener('input', () => { clearTimeout(timer); controller?.abort(); generation++; timer = setTimeout(run, 220); });
        form.addEventListener('submit', event => { event.preventDefault(); clearTimeout(timer); run(); });
      });
    }
    async function openSearch(opener) {
      show(searchDialog, opener);
      if (panelBody(searchDialog).querySelector('[data-search-surface]')) { panelBody(searchDialog).querySelector('input[type=search]').focus(); return; }
      loading(searchDialog); requests.get(searchDialog)?.abort(); const controller = new AbortController(); requests.set(searchDialog,controller);
      try { const surface = await section(searchUrl(''), 'petgraf-search','[data-search-surface]',controller.signal); if(controller.signal.aborted || !searchDialog.open) return; panelBody(searchDialog).replaceChildren(surface); bindSearch(surface.parentElement); surface.querySelector('input[type=search]').focus(); }
      catch(error) { if(error.name !== 'AbortError') errorPanel(searchDialog, () => openSearch(opener)); }
    }
    let logoConflicts = [], logoReviewFailed = false, logoFeedback = '', logoReviewPending = null;
    const dirtyLogoForms = new WeakSet();
    const logoCopy = {present:'Este logotipo já está no carrinho. Você paga por ele uma única vez.', edited:'Este logotipo já está no carrinho. Atualize os dados ou mantenha o nome e o subtítulo atuais.', repaired:'A duplicidade foi corrigida. Este logotipo aparece uma única vez no carrinho.', failed:'Não foi possível conferir os logotipos. Tente novamente antes de finalizar.'};
    async function logoCartAPI(route = '', body) {
      const response = await fetch(messages.cart + route + '.js', {method:body?'POST':'GET',headers:{'Content-Type':'application/json',Accept:'application/json'},...(body?{body:JSON.stringify(body)}:{cache:'no-store'}),signal:AbortSignal.timeout(30000)});
      const result = await response.json();
      if(!response.ok) throw new Error(result.description || messages.cartError);
      return result;
    }
    function logoProperties(form) {
      const value = name => (form.elements.namedItem('properties['+name+']')?.value || '').normalize('NFC').replace(/\s+/g,' ').trim();
      return {'Nome no logotipo':value('Nome no logotipo'),'Subtítulo':value('Subtítulo'),_pg_kind:'logo'};
    }
    function productLogoLine(form) {
      const id = String(form.elements.namedItem('id')?.value || '');
      return document.querySelector('[data-cart-content] [data-line-kind="logo"][data-variant-id="'+id+'"]');
    }
    function fillLogoForm(form, line) {
      for(const [name,value] of [['Nome no logotipo',line.dataset.logoName||''],['Subtítulo',line.dataset.logoSubtitle||'']]) { const field=form.elements.namedItem('properties['+name+']');if(field)field.value=value; }
    }
    function updateLogoStates() {
      const cart = document.querySelector('[data-cart-content]');
      document.querySelectorAll('[data-logo-variant-id]').forEach(card => {const badge=card.querySelector('[data-logo-cart-badge]');if(badge)badge.hidden=!cart?.querySelector('[data-line-kind="logo"][data-variant-id="'+card.dataset.logoVariantId+'"]');});
      document.querySelectorAll('[data-pg-product][data-line-kind="logo"] form').forEach(form => {
        const line=productLogoLine(form), button=form.querySelector('.pg-add'), box=form.querySelector('[data-logo-cart-state]');if(!button||!box)return;
        if(line&&!dirtyLogoForms.has(form)) fillLogoForm(form,line);
        const fields=logoProperties(form), changed=!!line&&(fields['Nome no logotipo']!==(line.dataset.logoName||'')||fields['Subtítulo']!==(line.dataset.logoSubtitle||''));
        button.toggleAttribute('data-logo-review',!!line);button.formNoValidate=!!line;form.noValidate=!!line;
        const label=button.querySelector('[data-add-label]');if(label)label.textContent=line?'Ver no carrinho':button.disabled?button.dataset.unavailableLabel:button.dataset.availableLabel;
        box.hidden=!line&&!form.dataset.logoError;box.querySelector('[data-logo-cart-status]').textContent=form.dataset.logoError||(changed?logoCopy.edited:logoCopy.present);
        box.querySelector('[data-logo-edit-actions]').hidden=!changed;
      });
    }
    function renderLogoReview() {
      document.querySelectorAll('[data-cart-form]').forEach(form => {
        form.querySelector('[data-logo-review-notice]')?.remove();
        const blocked=logoReviewFailed||logoConflicts.length>0;
        const checkout=form.querySelector('button[name="checkout"]');
        if(blocked){if(checkout&&!form.hasAttribute('data-logo-blocked'))checkout.dataset.logoPreviousDisabled=String(checkout.disabled);form.dataset.logoBlocked='true';if(checkout)checkout.disabled=true;}
        else if(form.hasAttribute('data-logo-blocked')){delete form.dataset.logoBlocked;if(checkout){checkout.disabled=checkout.dataset.logoPreviousDisabled==='true';delete checkout.dataset.logoPreviousDisabled;}}
        if(!blocked&&!logoFeedback)return;
        const box=document.createElement('div');box.dataset.logoReviewNotice='';box.className='pg-logo-cart-state';box.setAttribute('role','status');box.setAttribute('aria-live','polite');
        const text=document.createElement('p');text.textContent=logoReviewFailed?logoCopy.failed:logoConflicts.length?'Este logotipo está no carrinho com dados diferentes. Escolha os dados que deseja manter.':logoFeedback;box.append(text);
        if(logoReviewFailed){const retry=document.createElement('button');retry.type='button';retry.className='pg-button';retry.dataset.logoRetry='';retry.textContent='Conferir novamente';box.append(retry);}
        for(const conflict of logoConflicts){for(const line of conflict.lines){const row=document.createElement('div'),label=document.createElement('p'),choose=document.createElement('button');label.textContent=(line.product_title||line.title||'Logotipo exclusivo')+' · '+(line.properties?.['Nome no logotipo']||'Sem nome')+(line.properties?.['Subtítulo']?' · '+line.properties['Subtítulo']:'');choose.type='button';choose.className='pg-button';choose.dataset.logoResolve=line.key;choose.dataset.logoVariant=conflict.variantId;choose.textContent='Usar estes dados';row.append(label,choose);box.append(row);}}
        form.prepend(box);
      });
    }
    function logoUpdated(result) {
      const line=result.line;
      if(line)document.dispatchEvent(new CustomEvent('pg:logo-updated',{detail:{line,cart:result.cart,variantId:String(line.variant_id),properties:line.properties}}));
    }
    function reviewLogos() {
      if(logoReviewPending)return logoReviewPending;
      logoReviewPending=window.petgrafCart.exclusive(async()=>{
        try {const result=await window.petgrafDesignCart.reconcileLogos(logoCartAPI);logoConflicts=window.petgrafDesignCart.logoConflicts(result.cart);logoReviewFailed=false;logoFeedback=result.repaired?logoCopy.repaired:'';await refreshCart();return result;}
        catch(error){logoReviewFailed=true;renderLogoReview();throw error;}
      }).finally(()=>{logoReviewPending=null;});
      return logoReviewPending;
    }
    async function purchaseLogo(form, update = false) {
      if(logoReviewPending)await logoReviewPending.catch(()=>{});
      if(cartBusy)return;
      delete form.dataset.logoError;dirtyLogoForms.add(form);
      const button=form.querySelector('.pg-add'), controls=[...form.elements], disabled=controls.map(control=>control.disabled);
      const properties=logoProperties(form),variantId=String(form.elements.namedItem('id')?.value||'');
      try {
        await window.petgrafCart.exclusive(async()=>{
          controls.forEach(control=>control.disabled=true);button?.setAttribute('aria-busy','true');
          const result=await window.petgrafDesignCart.ensureLogo(logoCartAPI,{variantId,properties,update});
          logoConflicts=window.petgrafDesignCart.logoConflicts(result.cart);logoReviewFailed=false;
          logoFeedback=result.repaired?logoCopy.repaired:result.status==='already-present'?logoCopy.present:result.status==='updated'?'Nome e subtítulo atualizados. O logotipo continua com uma única cobrança.':'';
          if(result.status==='added'||result.status==='updated')dirtyLogoForms.delete(form);
          await refreshCart();
          if(result.status==='updated')logoUpdated(result);
          if(result.status==='added')document.dispatchEvent(new CustomEvent('pg:logo-added',{detail:{variantId}}));
          if(result.status==='conflict'){if(logoConflicts.length)show(cartDialog,button);else {const notice=form.querySelector('[data-logo-cart-status]');if(notice){notice.tabIndex=-1;notice.focus({preventScroll:true});}}return;}
          if(result.status==='already-present')dirtyLogoForms.delete(form);
          show(cartDialog,button);notify(logoFeedback||messages.added);
        });
      }catch(error){logoReviewFailed=true;renderLogoReview();form.dataset.logoError=error.message||logoCopy.failed;const box=form.querySelector('[data-logo-cart-state]');if(box){box.hidden=false;box.querySelector('[data-logo-cart-status]').textContent=error.message||logoCopy.failed;}notify(error.message||logoCopy.failed);}
      finally{controls.forEach((control,index)=>control.disabled=disabled[index]);button?.removeAttribute('aria-busy');updateLogoStates();}
    }
    function updateKitStates(content) {
      document.querySelectorAll('pg-kit[data-kit-id]').forEach(kit => {
        const lines = [...content.querySelectorAll('[data-line-key]')].filter(line => line.dataset.kitId === kit.dataset.kitId);
        const button = kit.querySelector('[data-kit-add]'), status = kit.querySelector('[data-kit-status]');
        const wasPending = kit.hasAttribute('data-kit-pending');
        kit.removeAttribute('data-kit-pending');
        button.toggleAttribute('data-cart-review', lines.length > 0);
        button.firstChild.textContent = lines.length ? messages.review + ' ' : kit.dataset.kitAddLabel + ' ';
        if (lines.length) {
          const complete = [...kit.querySelectorAll('[data-kit-item]')].every(input => lines.some(line => line.dataset.variantId === input.value));
          status.textContent = complete ? kit.dataset.kitAdded : kit.dataset.kitPartial;
        } else if (wasPending || status.dataset.inCart === 'true') status.textContent = '';
        status.dataset.inCart = String(lines.length > 0);
      });
    }
    function updateCartDOM(content) {
      const count = Number(content.dataset.count || 0);
      document.querySelectorAll('[data-rail-count]').forEach(badge=>{badge.textContent=String(count);badge.hidden=count===0;});
      document.querySelectorAll('[data-cart-content]').forEach(node => {
        const active = document.activeElement, hadFocus = node.contains(active);
        const index = [...node.querySelectorAll('[data-remove-line]')].indexOf(active);
        const replacement = content.cloneNode(true);
        node.replaceWith(replacement);
        if (hadFocus) {
          const removers = [...replacement.querySelectorAll('[data-remove-line]')];
          const target = index >= 0 ? removers[Math.min(index, removers.length - 1)] : replacement.querySelector('[data-clear-cart]');
          (target || replacement.querySelector('button[name=checkout],a.pg-button'))?.focus({preventScroll:true});
        }
      });
      updateKitStates(content);
      window.petgrafDesign?.renderState();
      updateLogoStates();renderLogoReview();
      document.querySelectorAll('a').forEach(link => {
        if (new URL(link.href,location.origin).pathname !== messages.cart || (!link.closest('.pg-header-actions') && !link.closest('.pg-bottom,.pg-app-dock') && !link.closest('.pg-rail'))) return;
        if(link.querySelector('[data-rail-count]'))return;
        let badge = link.querySelector('.pg-count');
        if (!badge && count) { badge = document.createElement('span'); badge.className = 'pg-count'; link.append(badge); }
        if (badge) { badge.textContent = String(count); badge.hidden = count === 0; }
      });
    }
    async function refreshCart() {
      const content = await section(messages.cart,'petgraf-cart','[data-cart-content]');
      if(!panelBody(cartDialog).querySelector('[data-cart-content]')) panelBody(cartDialog).replaceChildren(content.cloneNode(true));
      updateCartDOM(content);
    }
    async function openCart(opener) {
      show(cartDialog,opener);
      if(logoReviewPending){await logoReviewPending.catch(()=>{});return;}
      if(cartBusy) return;
      try { await reviewLogos(); } catch { renderLogoReview(); }
    }
    async function mutateCart(path, payload, form, nextStep, kit) {
      if(cartBusy || additionPending) return;
      if(path === messages.add) {
        additionPending = true;
        try {
          // Os materiais entram no carrinho sem exigir o Design. Com Design salvo, ele segue junto;
          // sem Design, a pessoa escolhe o modelo ou envia o logotipo no carrinho, antes de finalizar.
          if(window.petgrafDesign?.valid()) {
            if(payload instanceof FormData) { if(window.petgrafDesignCart.requiresDesign({id:payload.get('id'),kind:form?.closest('[data-pg-product]')?.dataset.lineKind})) Object.entries(window.petgrafDesign.properties()).forEach(([key,value])=>payload.set('properties['+key+']',value)); }
            else payload.items = payload.items.map(item=>({...item,properties:window.petgrafDesignCart.requiresDesign(item)?window.petgrafDesign.properties(item.properties):window.petgrafDesignCart.clearProperties(item.properties)}));
          }
        } catch(error) { notify(error.message); return; }
        finally { additionPending = false; }
      }
      let leaving = false, acknowledged = false;
      cartBusy = true;
      const isAdd = path === messages.add;
      const button = kit?.querySelector('[data-kit-add]') || form?.querySelector('button[type=submit]');
      const controls = form ? [...form.elements] : button ? [button] : [];
      const disabled = controls.map(control => control.disabled);
      controls.forEach(control => { control.disabled = true; });
      button?.setAttribute('aria-busy','true');
      if(kit) kit.querySelector('[data-kit-status]').textContent = messages.loading;
      document.querySelectorAll('[data-cart-content]').forEach(node => node.setAttribute('aria-busy','true'));
      try {
        if(isAdd && window.petgrafDesign?.valid()) await window.petgrafDesign.syncCart();
        const multipart = payload instanceof FormData;
        if(multipart){payload.set('sections','petgraf-cart');payload.set('sections_url',messages.cart);}
        const response = await fetch(path + '.js', {method:'POST',headers:multipart?{Accept:'application/json'}:{'Content-Type':'application/json',Accept:'application/json'},body:multipart?payload:JSON.stringify({...payload,sections:['petgraf-cart'],sections_url:messages.cart})});
        acknowledged = response.ok;
        const data = await response.json();
        if(!response.ok) throw new Error(messages.cartError);
        if(logoConflicts.length||document.querySelector('[data-line-kind="logo"][data-line-key]')){const reviewed=await window.petgrafDesignCart.reconcileLogos(logoCartAPI);logoConflicts=reviewed.conflicts;logoReviewFailed=false;logoFeedback=reviewed.repaired?logoCopy.repaired:'';if(reviewed.repaired)data.sections=null;}
        const content = data.sections?.['petgraf-cart'] ? parse(data.sections['petgraf-cart']).querySelector('[data-cart-content]') : null;
        if(content) updateCartDOM(content); else await refreshCart();
        if(isAdd) {
          notify(messages.added);
          if(form?.closest('[data-pg-product]')?.dataset.lineKind==='logo') document.dispatchEvent(new CustomEvent('pg:logo-added',{detail:{variantId:String(payload.get?.('id')||'')}}));
          window.petgrafDesign?.metric('add_complete',{count:payload.items?.length||1});
          const label=button?.querySelector('[data-add-label]');
          if(label){const previous=label.textContent;label.textContent=messages.added;button.classList.add('is-added');setTimeout(()=>{label.textContent=previous;button.classList.remove('is-added');},2000);}
          show(cartDialog,button);
        }
      } catch {
        if(isAdd) {
          if(kit) {
            kit.setAttribute('data-kit-pending','');
            button.setAttribute('data-cart-review','');
            button.firstChild.textContent = messages.review + ' ';
            kit.querySelector('[data-kit-status]').textContent = messages.checkBeforeRetry;
          }
          show(cartDialog,button);
          try { await refreshCart(); }
          catch { errorPanel(cartDialog, () => openCart(button)); }
          notify(acknowledged ? messages.added : messages.checkBeforeRetry);
        } else {
          try { await refreshCart(); } catch { errorPanel(cartDialog, () => openCart(button)); }
          notify(messages.cartError);
        }
      } finally {
        cartBusy = leaving;
        if(!leaving) controls.forEach((control,index) => { control.disabled = disabled[index]; });
        button?.removeAttribute('aria-busy');
        document.querySelectorAll('[data-cart-content]').forEach(node => node.removeAttribute('aria-busy'));
      }
    }
    window.petgrafCart = {
      refresh: refreshCart, notify, reviewLogos,
      async exclusive(work) {
        if(cartBusy) throw new Error('Aguarde a atualização do carrinho e tente novamente.');
        cartBusy = true;
        try { return await work(); } finally { cartBusy = false; }
      }
    };
    document.addEventListener('submit', event => {
      const form = event.target;
      if(form.matches('[data-pg-product] form')) {
        event.preventDefault();
        if(form.closest('[data-pg-product]').dataset.lineKind==='logo'){if(form.querySelector('[data-logo-review]')){openCart(form.querySelector('.pg-add'));return;}if(form.reportValidity())purchaseLogo(form);return;}
        if(!form.reportValidity()) return;
        const data = new FormData(); const selected = form.querySelector('select[name=id]')?.selectedOptions[0] || form.querySelector('[name=id]:checked') || form.querySelector('input[type="hidden"][name="id"]'); const id = selected?.value, quantity = 1;
        if(selected?.disabled || selected?.dataset.available === 'false') return;
        if(!id || !Number.isInteger(quantity) || quantity < 1) return;
        form.closest('[data-pg-product]').querySelector('[data-cart-error]')?.remove();
        data.set('id',id);data.set('quantity',String(quantity));
        // Propriedades do próprio formulário (ex.: nome e subtítulo do logotipo exclusivo) seguem para a linha.
        for(const field of form.querySelectorAll('[name^="properties["]')) { const value = field.value.trim(); if(value) data.set(field.name,value); }
        const reference=form.querySelector('[data-specialty-reference-property]');
        if(reference?.value)data.set('properties[Referência de arte]',reference.value);
        mutateCart(messages.add,data,form,event.submitter?.dataset.personalizationNext);
      } else if(form.matches('[data-cart-form]') && event.submitter?.name !== 'checkout') {
        event.preventDefault(); if(!form.reportValidity()) return;
        return;
      }
    });
    document.addEventListener('input', event => {const form=event.target.closest('[data-pg-product][data-line-kind="logo"] form');if(form&&event.target.name?.startsWith('properties[')){dirtyLogoForms.add(form);updateLogoStates();}});
    document.addEventListener('change', event => {
      const input = event.target.matches('[data-variant-select]') ? event.target.selectedOptions[0] : event.target;
      if(!input) return;
      if(input.matches('[data-price]')) {
        const root = input.closest('[data-pg-product]'); if (!root) return; root.querySelector('[data-pg-price]').textContent = input.dataset.price;root.querySelector('pg-installment-price')?.setAttribute('amount',input.dataset.priceCents); const pix=root.querySelector('[data-pg-pix-price]');if(pix)pix.textContent=input.dataset.pixPrice;
        const button=root.querySelector('.pg-add');button.disabled=input.disabled || input.dataset.available === 'false';button.classList.remove('is-added');button.querySelector('[data-add-label]').textContent=button.disabled ? button.dataset.unavailableLabel : button.dataset.availableLabel;
        root.querySelectorAll('[data-personalization-next]').forEach(action=>action.disabled=button.disabled);
        if(!root.closest('dialog')) { const url = new URL(location.href); url.searchParams.set('variant',input.value); history.replaceState(null,'',url); }
        else { productDialog.querySelectorAll('[data-full-product],[data-product-page-link]').forEach(link=>{const url=new URL(link.href);url.searchParams.set('variant',input.value);link.href=url;}); }
      } else if(input.matches('[data-line-quantity]') && input.reportValidity()) {
        const quantity = Number(input.value); if(!Number.isInteger(quantity) || quantity < 0) return;
        mutateCart(messages.change,{id:input.closest('[data-line-key]').dataset.lineKey,quantity},input.form);
      }
    });
    document.addEventListener('click', event => {
      if(event.defaultPrevented) return;
      const logoUpdate=event.target.closest('[data-logo-update]');if(logoUpdate){const form=logoUpdate.closest('form');if(form.reportValidity())purchaseLogo(form,true);return;}
      const logoKeep=event.target.closest('[data-logo-keep]');if(logoKeep){const form=logoKeep.closest('form');delete form.dataset.logoError;dirtyLogoForms.delete(form);updateLogoStates();return;}
      if(event.target.closest('[data-logo-retry]')){reviewLogos().catch(()=>{});return;}
      const resolve=event.target.closest('[data-logo-resolve]');if(resolve){
        if(cartBusy)return;
        window.petgrafCart.exclusive(async()=>{try{const result=await window.petgrafDesignCart.reconcileLogos(logoCartAPI,{variantId:resolve.dataset.logoVariant,keepKey:resolve.dataset.logoResolve});logoConflicts=window.petgrafDesignCart.logoConflicts(result.cart);logoReviewFailed=false;logoFeedback=logoCopy.repaired;await refreshCart();logoUpdated({cart:result.cart,line:result.cart.items.find(line=>String(line.variant_id)===resolve.dataset.logoVariant)});}catch(error){logoReviewFailed=true;renderLogoReview();notify(error.message);}});return;
      }
      const kitButton = event.target.closest('[data-kit-add]');
      if(kitButton) {
        if(kitButton.disabled || cartBusy) return;
        if(kitButton.hasAttribute('data-cart-review')) { openCart(kitButton); return; }
        const kit = kitButton.closest('pg-kit');
        const properties = {_pg_kit: kit.dataset.kitId};
        const items = [...kit.querySelectorAll('[data-kit-item]')].map(input => ({id:Number(input.value),quantity:1,properties}));
        if(items.length && items.every(item => Number.isSafeInteger(item.id) && item.id > 0)) mutateCart(messages.add,{items},null,null,kit);
        return;
      }
      const clearButton=event.target.closest('[data-clear-cart]');if(clearButton){const form=clearButton.closest('form'),updates={};form.querySelectorAll('[data-line-key]').forEach(line=>updates[line.dataset.lineKey]=0);mutateCart(messages.update,{updates},form);return;}
      const specsButton = event.target.closest('[data-open-specs]');
      if(specsButton) { const root = specsButton.closest('[data-pg-product]'), dialog = runtime.querySelector('[data-specs-dialog]'); dialog.querySelector('[data-specs-title]').textContent = root.querySelector('h1').textContent; panelBody(dialog).replaceChildren(root.querySelector('[data-specs-template]').content.cloneNode(true)); show(dialog,specsButton); return; }
      if(event.target.closest('[data-close-dialog]')) { close(event.target.closest('dialog')); return; }
      if(event.target.closest('[data-product-prev]')) { nextProduct(-1); return; }
      if(event.target.closest('[data-product-next]')) { nextProduct(1); return; }
      const link = event.target.closest('a');
      if(!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      if(link.matches('[data-pg-image]')) { event.preventDefault(); const root = link.closest('[data-pg-product]'), image = root.querySelector('.pg-product-image'); image.removeAttribute('srcset'); image.src = link.href; image.alt = link.querySelector('img')?.alt || ''; root.querySelectorAll('[data-pg-image]').forEach(node => node.removeAttribute('aria-current')); link.setAttribute('aria-current','true'); return; }
      if(link.matches('[data-remove-line]')) { event.preventDefault(); mutateCart(messages.change,{id:link.closest('[data-line-key]').dataset.lineKey,quantity:0},link.closest('form')); return; }
      const url = new URL(link.href,location.origin);
      if(url.origin !== location.origin) return;
      if(link.matches('[data-kit-product]')){event.preventDefault();productLinks=[];openProduct(link.href,link,true);return;}
      if(url.pathname === messages.search && !url.search) { event.preventDefault(); openSearch(link); }
      else if(url.pathname === messages.cart && !url.search) { event.preventDefault(); openCart(link); }
      else if(link.matches('.pg-card')) { if(link.closest('.pg-search-surface')) close(searchDialog); return; }
    });
    productDialog.addEventListener('keydown', event => { if(cartDialog.open || runtime.querySelector('[data-specs-dialog]').open || event.target.closest('[data-gallery]') || event.target.matches('input,textarea,select')) return; if(event.key === 'ArrowLeft') { event.preventDefault(); nextProduct(-1); } if(event.key === 'ArrowRight') { event.preventDefault(); nextProduct(1); } });
    const initialCart = panelBody(cartDialog).querySelector('[data-cart-content]');
    if(initialCart) updateKitStates(initialCart);
    updateLogoStates();
    const checkLogos=()=>{if(!cartBusy&&window.petgrafDesignCart?.reconcileLogos)reviewLogos().catch(()=>{});};
    window.addEventListener('pageshow',event=>{if(event.persisted)checkLogos();});
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',checkLogos,{once:true});else checkLogos();
    bindSearch(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petgraf-quote-page"]) return;
  try {
    
(()=>{
  const page=document.querySelector('[data-quote-page]');if(!page)return;
  const money=cents=>new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(cents/100).replace(/\s/g,' ');
  const rows=[...page.querySelectorAll('[data-quote-product]')];
  const checked=row=>row.querySelector('[data-quote-form] input[name="id"]:checked');
  const selection=()=>rows.map(row=>{const input=checked(row);return input&&!input.disabled?{row,id:Number(input.value),price:Number(input.dataset.priceCents),title:row.dataset.title,short:row.dataset.short||row.dataset.title,run:input.dataset.runTitle||''}:null;}).filter(Boolean);
  const buy=page.querySelector('[data-quote-buy]'),status=page.querySelector('[data-quote-status]');
  const dock=page.querySelector('[data-quote-dock]'),dockEnd=page.querySelector('[data-quote-dock-end]');
  // O resumo fica preso na base enquanto há lista abaixo; ao chegar no fim, assenta no lugar e mostra frete, parcelas e o botão.
  // Mede pela marca antes do resumo (não se move quando o resumo cresce), para não alternar entre preso e solto.
  const dockStart=page.querySelector('[data-quote-dock-start]');let shortH=0,stickBottom=16;
  const measure=()=>{if(!dock)return;const was=dock.classList.contains('is-docked');dock.classList.remove('is-docked');shortH=dock.offsetHeight;const b=parseFloat(getComputedStyle(dock).bottom);if(!Number.isNaN(b))stickBottom=b;dock.classList.toggle('is-docked',was);};
  let jumping=false;
  // Com material escolhido, o resumo sai da lista e flutua até o fim da página: vai para o fim do <main> num contêiner
  // preso na base da tela e assenta antes do rodapé. Sem material, volta ao lugar no fim da lista.
  const mainEl=page.closest('main')||document.querySelector('main');const floatHost=document.createElement('div');floatHost.className='pg-container pg-quote-float';
  const syncFloat=()=>{if(!dock||!dockEnd||!mainEl)return;const has=dock.classList.contains('has-items');if(has&&dock.parentNode!==floatHost){floatHost.append(dock);mainEl.append(floatHost);}else if(!has&&dock.parentNode===floatHost){dockEnd.before(dock);floatHost.remove();}};
  const dockCheck=()=>{if(!dock||!dockStart||jumping)return;if(!dock.classList.contains('has-items')){dock.classList.add('is-docked');return;}if(!shortH)measure();const top=dockStart.getBoundingClientRect().top+parseFloat(getComputedStyle(dock).marginTop||'0');dock.classList.toggle('is-docked',top+shortH<=innerHeight-stickBottom+1);};
  addEventListener('scroll',dockCheck,{passive:true});addEventListener('resize',()=>{measure();dockCheck();});
  let busy=false;
  function render(){
    const chosen=selection(),total=chosen.reduce((sum,item)=>sum+item.price,0);
    rows.forEach(row=>{
      const picked=chosen.find(item=>item.row===row);
      row.classList.toggle('is-selected',!!picked);
      row.querySelector('[data-quote-added]').hidden=!picked;
      row.querySelector('[data-quote-price]').hidden=!picked;
      if(picked)row.querySelector('[data-quote-price] pg-installment-price')?.setAttribute('amount',String(picked.price));
    });
    dock.querySelector('[data-quote-count]').hidden=!!chosen.length;
    dock.querySelector('[data-quote-total]').textContent=money(total);
    const mini=dock;if(mini){mini.classList.toggle('has-items',!!chosen.length);const list=mini.querySelector('[data-quote-mini-lines]');list.hidden=!chosen.length;list.replaceChildren();const shown=chosen;shown.forEach(item=>{const n=(item.run.match(/\d[\d.]*/)||[''])[0],blocks=/bloco/i.test(item.run),li=document.createElement('li'),label=document.createElement('span'),amount=document.createElement('small');label.textContent=(n?n+' '+(blocks?(n==='1'?'bloco ':'blocos '):''):'')+item.short;amount.textContent=money(item.price);const rm=document.createElement('button');rm.type='button';rm.className='pg-quote-mini-remove';rm.textContent='\u2212';rm.setAttribute('aria-label','Tirar '+item.title+' do orçamento');rm.dataset.quoteMiniRemove=item.row.dataset.quoteProduct;li.append(rm,label,amount);list.append(li);});if(chosen.length>shown.length){const li=document.createElement('li'),more=document.createElement('span');more.textContent='+ '+(chosen.length-shown.length)+(chosen.length-shown.length===1?' material':' materiais');li.append(more);list.append(li);}}
    buy.disabled=busy||!chosen.length;buy.toggleAttribute('aria-busy',busy);
    syncFloat();
    if(chosen.length)measure();dockCheck();
  }
  // Desmarca a quantidade e avisa o pg-quantity-options (a sugestão de quantidade some junto).
  function clear(row){
    const form=row.querySelector('[data-quote-form]');
    form.querySelectorAll('input[name="id"]').forEach(input=>{input.checked=false;});
    form.querySelector('pg-quantity-options')?.dispatchEvent(new Event('change',{bubbles:true}));
  }
  page.addEventListener('submit',event=>{if(event.target.matches('[data-quote-form]'))event.preventDefault();});
  // O ouvinte global de troca de variante (petgraf-panels) espera uma página de produto; aqui a troca fica na seção.
  page.addEventListener('change',event=>{if(!event.target.closest('[data-quote-form]'))return;event.stopPropagation();status.textContent='';status.classList.remove('is-error');render();});
  // Popup "Ver mais": conteúdo vem do <template> da linha, sem sair da página e sem preço.
  const dialog=page.querySelector('[data-quote-dialog]'),root=document.documentElement;
  let current=null;
  let photoIndex=0;
  const swiping=track=>getComputedStyle(track).display==='flex';
  function markGallery(index){
    const track=dialog.querySelector('[data-qd-track]');if(!track)return;
    const count=track.children.length;photoIndex=Math.max(0,Math.min(count-1,index));
    [...track.children].forEach((photo,i)=>{photo.classList.toggle('is-active',i===photoIndex);photo.setAttribute('aria-hidden',String(i!==photoIndex&&!swiping(track)));});
    dialog.querySelectorAll('[data-qd-go]').forEach((thumb,i)=>thumb.toggleAttribute('aria-current',i===photoIndex));
    const prev=dialog.querySelector('[data-qd-step="-1"]'),next=dialog.querySelector('[data-qd-step="1"]');
    if(prev)prev.disabled=photoIndex<=0;if(next)next.disabled=photoIndex>=count-1;
  }
  function goTo(index){
    const track=dialog.querySelector('[data-qd-track]');if(!track)return;
    markGallery(index);
    if(swiping(track)){const photo=track.children[photoIndex];track.scrollTo({left:photo.offsetLeft-track.firstElementChild.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  }
  // Celular: tocar na foto do popup amplia ali mesmo (como na galeria do produto); arrastar a galeria desfaz.
  const phone=matchMedia('(max-width:767px)');
  function setZoom(figure,on,origin){
    const image=figure.querySelector('img'),button=figure.querySelector('[data-qd-zoom]');if(!image||!button)return;
    if(on){image.style.transformOrigin=origin||'50% 50%';if(!image.dataset.sizes)image.dataset.sizes=image.sizes;image.sizes=Math.ceil(figure.clientWidth*1.8)+'px';}
    figure.toggleAttribute('data-zoomed',on);button.setAttribute('aria-pressed',String(on));button.setAttribute('aria-label',on?button.dataset.zoomOut:button.dataset.zoomIn);
  }
  const unzoom=()=>dialog.querySelectorAll('.pg-qd-photo[data-zoomed]').forEach(figure=>setZoom(figure,false));
  function syncGallery(){const track=dialog.querySelector('[data-qd-track]');if(!track||!swiping(track))return;const width=track.firstElementChild?.offsetWidth||track.clientWidth;markGallery(Math.round(track.scrollLeft/Math.max(1,width)));}
  function openDetail(row){
    const template=page.querySelector('template[data-quote-detail="'+row.dataset.quoteProduct+'"]');if(!template||!dialog)return;
    dialog.replaceChildren(template.content.cloneNode(true));
    // A descrição vem do Admin: links viram texto para o popup não levar a outra página.
    dialog.querySelectorAll('.pg-qd-rte a').forEach(link=>link.replaceWith(...link.childNodes));
    current=row;
    dialog.querySelector('[data-qd-track]')?.addEventListener('scroll',()=>{unzoom();requestAnimationFrame(syncGallery);},{passive:true});
    try{dialog.showModal();}catch{dialog.setAttribute('open','');}
    root.classList.add('pg-panel-open');
    dialog.scrollTop=0;
    dialog.querySelector('#pg-qd-title')?.focus({preventScroll:true});
    markGallery(0);
  }
  function closeDetail(){if(dialog.open)dialog.close();}
  // 'toggle' em vez de 'close': neste tema o 'close' do dialog não chega aos ouvintes colocados nele.
  dialog?.addEventListener('toggle',event=>{
    if(event.newState!=='closed')return;
    if(!document.querySelector('dialog[open]'))root.classList.remove('pg-panel-open');
    current?.querySelector('.pg-quote-more')?.focus({preventScroll:true});
    current=null;
  });
  dialog?.addEventListener('click',event=>{
    if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom){closeDetail();return;}}
    if(event.target.closest('[data-qd-close]')){closeDetail();return;}
    const zoom=event.target.closest('[data-qd-zoom]');
    if(zoom){if(!phone.matches)return;const figure=zoom.closest('.pg-qd-photo'),on=!figure.hasAttribute('data-zoomed'),r=figure.getBoundingClientRect();setZoom(figure,on,event.detail===0?'50% 50%':Math.max(0,Math.min(100,(event.clientX-r.left)/r.width*100))+'% '+Math.max(0,Math.min(100,(event.clientY-r.top)/r.height*100))+'%');return;}
    const step=event.target.closest('[data-qd-step]');
    if(step){goTo(photoIndex+Number(step.dataset.qdStep));return;}
    const go=event.target.closest('[data-qd-go]');if(go)goTo(Number(go.dataset.qdGo));
  });
  dialog?.addEventListener('keydown',event=>{
    if(!event.target.matches('[data-qd-track]'))return;
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();goTo(photoIndex+(event.key==='ArrowRight'?1:-1));}
  });
  const onPageClick=async event=>{
    const open=event.target.closest('[data-quote-open]');
    if(open){openDetail(open.closest('[data-quote-product]'));return;}
    const miniRemove=event.target.closest('[data-quote-mini-remove]');
    if(miniRemove){const row=page.querySelector('[data-quote-product="'+miniRemove.dataset.quoteMiniRemove+'"]');if(row)clear(row);return;}
    const remove=event.target.closest('[data-quote-remove]');
    if(remove){const row=remove.closest('[data-quote-product]');clear(row);row.querySelector('[data-quote-form] input[name="id"]:not(:disabled)')?.focus({preventScroll:true});return;}
    const jump=event.target.closest('.pg-quote-jump,[data-quote-dock-go]');
    if(jump){event.preventDefault();const behavior=matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth';
      // Assenta o resumo já no destino (fica com a altura final), rola uma vez até lá e só volta a medir quando a rolagem termina.
      jumping=true;dock.classList.add('is-docked');
      let done=false,idle=0;const finish=()=>{if(done)return;done=true;clearTimeout(idle);clearTimeout(cap);removeEventListener('scroll',onScroll);jumping=false;dockCheck();buy.focus({preventScroll:true});};
      const onScroll=()=>{clearTimeout(idle);idle=setTimeout(finish,200);};const cap=setTimeout(finish,6000);
      addEventListener('scroll',onScroll,{passive:true});addEventListener('scrollend',finish,{once:true});idle=setTimeout(finish,400);
      dockEnd.scrollIntoView({behavior,block:'end'});return;}
    if(!event.target.closest('[data-quote-buy]')||busy)return;
    const chosen=selection();if(!chosen.length)return;
    busy=true;status.classList.remove('is-error');status.textContent='Levando os materiais para o carrinho…';render();
    try{
      const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:chosen.map(item=>({id:item.id,quantity:1,properties:{_pg_quote:'orcamento'}}))})});
      if(!response.ok)throw new Error((await response.json().catch(()=>({}))).description||'Não foi possível adicionar agora. Tente de novo.');
      status.textContent='';
      rows.forEach(clear);
      await window.petgrafCart?.refresh?.();
      document.querySelector('a[href="/cart"],a[href$="/cart"]')?.click();
    }catch(error){status.classList.add('is-error');status.textContent=error.message;}
    finally{busy=false;render();}
  };
  page.addEventListener('click',onPageClick);floatHost.addEventListener('click',onPageClick);
  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petgraf-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pg-review-list'))customElements.define('pg-review-list',class extends HTMLElement{
 connectedCallback(){
  /* Mesmo movimento da vitrine de pastas e envelopes: trilho contínuo e lento com clones antes e depois,
     avanço em scrollLeft (rAF). Pausa com o mouse sobre um depoimento (não sobre a seção inteira), foco por
     teclado, toque, avaliação expandida, aba oculta ou botão de pausa. No celular, sem movimento automático. */
  this.viewport=this.querySelector('.pg-reviews-viewport');
  this.track=this.querySelector('.pg-reviews-track');
  this.group=this.querySelector('.pg-reviews-group');
  this.prev=this.querySelector('[data-reviews-prev]');
  this.next=this.querySelector('[data-reviews-next]');
  this.toggle=this.querySelector('[data-reviews-toggle]');
  this.abort?.abort();cancelAnimationFrame(this.raf);this.abort=new AbortController();const {signal}=this.abort;
  const viewport=this.viewport,track=this.track,group=this.group;
  if(!viewport||!track||!group)return;
  const SPEED=22,RESUME_DELAY=1400;
  const reducedMotion=matchMedia('(prefers-reduced-motion:reduce)');
  const mobileViewport=matchMedia('(max-width:767px)');
  const designMode=!!(window.Shopify&&window.Shopify.designMode);
  let cycle=0,pos=0,visible=false,hovering=false,pressing=false,lastTick=0,lastUser=0,quiet=0;
  this.raf=0;
  this.userPaused=reducedMotion.matches;
  const PAUSE_ICON='<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
  const PLAY_ICON='<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5Z"/></svg>';
  const updateToggle=()=>{if(!this.toggle)return;this.toggle.setAttribute('aria-pressed',String(this.userPaused));this.toggle.setAttribute('aria-label',this.userPaused?'Retomar reprodução automática':'Pausar reprodução automática');this.toggle.innerHTML=this.userPaused?PLAY_ICON:PAUSE_ICON;};
  this.toggle?.addEventListener('click',()=>{this.userPaused=!this.userPaused;lastTick=0;updateToggle();start();},{signal});updateToggle();
  /* Delegado para funcionar também nos clones do loop. */
  this.addEventListener('click',event=>{const button=event.target.closest('[data-review-expand]');if(!button||!this.contains(button))return;const expanded=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!expanded));button.closest('.pg-review').classList.toggle('is-expanded',!expanded);button.textContent=expanded?'Ler avaliação completa':'Recolher avaliação';lastUser=performance.now();lastTick=0;},{signal});
  this.addEventListener('error',event=>{const img=event.target;if(!(img instanceof HTMLImageElement))return;if(img.closest('.pg-review-faces'))img.remove();else if(img.closest('.pg-review-avatar'))img.hidden=true;},{signal,capture:true});
  const active=()=>cycle>0&&!reducedMotion.matches;
  const focused=()=>{const el=document.activeElement;if(!el||!viewport.contains(el))return false;try{return el.matches(':focus-visible');}catch(e){return true;}};
  const paused=()=>!active()||this.userPaused||!visible||hovering||pressing||focused()||document.hidden||!!viewport.querySelector('.pg-review.is-expanded')||performance.now()-lastUser<RESUME_DELAY;
  const wrap=value=>{if(!cycle)return value;if(value<cycle*.5)return value+cycle;if(value>=cycle*1.5)return value-cycle;return value;};
  const normalize=()=>{if(!active()||pressing)return;const next=wrap(viewport.scrollLeft);if(next!==viewport.scrollLeft){pos=next;viewport.scrollLeft=next;}};
  const update=()=>{if(!this.prev||!this.next)return;if(cycle){this.prev.disabled=false;this.next.disabled=false;return;}const max=viewport.scrollWidth-viewport.clientWidth;this.prev.disabled=viewport.scrollLeft<2;this.next.disabled=viewport.scrollLeft>=max-2;};
  const tick=now=>{this.raf=0;if(!active())return;if(paused()){lastTick=0;this.raf=requestAnimationFrame(tick);return;}if(!lastTick){lastTick=now;pos=viewport.scrollLeft;}const dt=Math.min(now-lastTick,64);lastTick=now;pos=wrap(pos+SPEED*dt/1000);viewport.scrollLeft=pos;this.raf=requestAnimationFrame(tick);};
  const start=()=>{if(!this.raf&&active())this.raf=requestAnimationFrame(tick);};
  const clone=node=>{const copy=node.cloneNode(true);copy.setAttribute('data-reviews-clone','true');copy.setAttribute('aria-hidden','true');[copy,...copy.querySelectorAll('*')].forEach(el=>{el.removeAttribute('id');el.removeAttribute('data-shopify-editor-block');if(el.matches('a,button,input,select,textarea,[tabindex]'))el.tabIndex=-1;});return copy;};
  const setup=()=>{
   track.querySelectorAll('[data-reviews-clone]').forEach(node=>node.remove());
   viewport.removeAttribute('data-looping');cycle=0;
   if(reducedMotion.matches||designMode||mobileViewport.matches||group.children.length<2){update();return;}
   const before=clone(group),after=clone(group);
   track.insertBefore(before,group);track.appendChild(after);
   cycle=group.offsetLeft-before.offsetLeft;
   if(cycle<=0){before.remove();after.remove();cycle=0;update();return;}
   viewport.setAttribute('data-looping','true');
   pos=cycle;viewport.scrollLeft=cycle;lastTick=0;update();start();
  };
  this.cleanupClones=()=>{track.querySelectorAll('[data-reviews-clone]').forEach(node=>node.remove());viewport.removeAttribute('data-looping');};
  const move=direction=>{const cards=group.children;const distance=cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:viewport.clientWidth*.85;lastUser=performance.now()+600;lastTick=0;if(active()){normalize();pos=viewport.scrollLeft;}viewport.scrollBy({left:direction*distance,behavior:reducedMotion.matches?'auto':'smooth'});};
  this.prev?.addEventListener('click',()=>move(-1),{signal});this.next?.addEventListener('click',()=>move(1),{signal});
  viewport.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}},{signal});
  viewport.addEventListener('scroll',()=>{update();if(!active())return;if(Math.abs(viewport.scrollLeft-pos)>1.5){pos=viewport.scrollLeft;lastUser=Math.max(lastUser,performance.now());lastTick=0;}clearTimeout(quiet);quiet=setTimeout(normalize,160);},{passive:true,signal});
  /* Cursor v2: o mouse por cima NÃO pausa mais o movimento (pausam o teclado/foco, o botão de pausa, a expansão de um depoimento e o toque/arraste). */
  /* Arraste com o mouse (cursor nativo de mão); clique que termina um arraste é descartado. */
  let dragId=null,dragX=0,dragStart=0,dragged=false;
  viewport.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('a,button,input,select,textarea,summary'))return;dragId=event.pointerId;dragX=event.clientX;dragStart=viewport.scrollLeft;dragged=false;},{signal});
  viewport.addEventListener('pointermove',event=>{if(dragId!==event.pointerId)return;const dist=event.clientX-dragX;if(!dragged){if(Math.abs(dist)<6)return;dragged=true;viewport.classList.add('is-dragging');try{viewport.setPointerCapture(event.pointerId);}catch(e){}}viewport.scrollLeft=dragStart-dist;event.preventDefault();},{signal});
  const endDrag=event=>{if(dragId===null||(event&&event.pointerId!==undefined&&event.pointerId!==dragId))return;dragId=null;viewport.classList.remove('is-dragging');lastUser=performance.now();lastTick=0;};
  viewport.addEventListener('pointerup',endDrag,{signal});viewport.addEventListener('pointercancel',endDrag,{signal});viewport.addEventListener('lostpointercapture',endDrag,{signal});
  viewport.addEventListener('click',event=>{if(dragged){event.preventDefault();event.stopPropagation();dragged=false;}},{capture:true,signal});
  viewport.addEventListener('dragstart',event=>event.preventDefault(),{signal});
  viewport.addEventListener('pointerdown',()=>{pressing=true;lastUser=performance.now();},{signal});
  const release=()=>{if(!pressing)return;pressing=false;lastUser=performance.now();lastTick=0;};
  window.addEventListener('pointerup',release,{signal});window.addEventListener('pointercancel',release,{signal});
  viewport.addEventListener('touchstart',()=>{pressing=true;lastUser=performance.now();},{passive:true,signal});
  viewport.addEventListener('touchend',release,{passive:true,signal});viewport.addEventListener('touchcancel',release,{passive:true,signal});
  viewport.addEventListener('wheel',()=>{lastUser=performance.now();lastTick=0;},{passive:true,signal});
  this.addEventListener('focusout',()=>{lastUser=performance.now();lastTick=0;},{signal});
  document.addEventListener('visibilitychange',()=>{lastTick=0;},{signal});
  reducedMotion.addEventListener('change',setup,{signal});mobileViewport.addEventListener('change',setup,{signal});
  this.visibility=new IntersectionObserver(entries=>{visible=entries[0]?.isIntersecting||false;lastTick=0;start();},{threshold:.2});this.visibility.observe(this);
  let width;
  this.resize=new ResizeObserver(entries=>{const next=Math.round(entries[0].contentRect.width);if(width===next)return;width=next;setup();});this.resize.observe(viewport);
  setup();
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.visibility?.disconnect();cancelAnimationFrame(this.raf);this.raf=0;this.cleanupClones?.();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petgraf-shell"]) return;
  try {
    
  if (!customElements.get('pg-navigation')) customElements.define('pg-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const {signal} = this.abort;
      const drawer = this.querySelector('dialog');
      const openers = this.querySelectorAll('[data-menu-open]'); let opener;
      const desktopMenus = [...this.querySelectorAll('.pg-desktop-nav .pg-materials-menu')];
      let activeMenu = null;
      const setActiveMenu = menu => {
        desktopMenus.forEach(candidate => { candidate.open = candidate === menu; });
        activeMenu = menu;
      };
      const closeDesktopMenus = () => setActiveMenu(null);
      setActiveMenu(desktopMenus.find(menu => menu.open) || null);
      desktopMenus.forEach(menu => {
        const summary = menu.querySelector('summary');
        summary.addEventListener('click', event => {
          event.preventDefault();
          setActiveMenu(menu.open ? null : menu);
        }, {signal});
        summary.addEventListener('keydown', event => {
          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
          event.preventDefault();
          setActiveMenu(menu);
          const links = [...menu.querySelectorAll('.pg-mega-menu a[href], .pg-mega-menu button:not(:disabled)')];
          (event.key === 'ArrowDown' ? links[0] : links[links.length - 1])?.focus();
        }, {signal});
        menu.addEventListener('toggle', () => {
          if (menu.open && activeMenu !== menu) setActiveMenu(menu);
          else if (!menu.open && activeMenu === menu) activeMenu = null;
        }, {signal});
      });
      const motionOk = () => !matchMedia('(prefers-reduced-motion: reduce)').matches;
      let closeToken = 0, menuActive = false;
      const finishClose = () => {
        if (drawer.open || !menuActive) return;
        menuActive = false;
        document.documentElement.classList.remove('pg-menu-is-open');
        openers.forEach(button=>button.setAttribute('aria-expanded', 'false'));
        opener?.focus({preventScroll:true});
      };
      const close = () => {
        if (!drawer.open) return;
        const token = ++closeToken;
        let settled = false;
        const settle = () => { if (settled) return; settled = true; if (token === closeToken) { if (drawer.open) drawer.close(); finishClose(); } };
        if (!motionOk() || !drawer.animate) { settle(); return; }
        try { drawer.animate([{transform:'translateY(0)'},{transform:'translateY(-100%)'}], {duration:200,easing:'cubic-bezier(.32,0,.67,0)'}).finished.then(settle, settle); }
        catch (error) { settle(); return; }
        setTimeout(settle, 400);
      };
      openers.forEach(button => button.addEventListener('click', () => {
        closeDesktopMenus();
        opener=button; closeToken++; menuActive=true;
        drawer.showModal(); openers.forEach(button=>button.setAttribute('aria-expanded', 'true')); document.documentElement.classList.add('pg-menu-is-open');
        drawer.querySelector('[data-menu-focus]')?.focus({preventScroll:true});
        if (motionOk()) drawer.animate([{transform:'translateY(-100%)'},{transform:'translateY(0)'}], {duration:280,easing:'cubic-bezier(.23,1,.32,1)'});
      }, {signal}));
      drawer.addEventListener('cancel', event => { event.preventDefault(); close(); }, {signal});
      drawer.addEventListener('close', finishClose, {signal});
      drawer.addEventListener('click', event => {
        if (event.target.closest('a,[data-menu-close]')) close();
        if (event.target === drawer) { const box = drawer.getBoundingClientRect(); if (event.clientX > box.right || event.clientX < box.left) close(); }
      }, {signal});
      document.addEventListener('click', event => {
        if (activeMenu && !activeMenu.contains(event.target)) closeDesktopMenus();
      }, {signal});
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !activeMenu) return;
        event.preventDefault();
        const summary = activeMenu.querySelector('summary');
        closeDesktopMenus();
        summary.focus();
      }, {signal});
      this.addEventListener('focusout', event => {
        if (activeMenu && event.relatedTarget && !activeMenu.contains(event.relatedTarget)) closeDesktopMenus();
      }, {signal});
      matchMedia('(min-width:1024px)').addEventListener('change', event => {
        closeDesktopMenus();
        if (event.matches) close();
      }, {signal});
    }
    disconnectedCallback() { this.abort?.abort(); this.querySelectorAll('.pg-desktop-nav .pg-materials-menu').forEach(menu => { menu.open = false; }); this.querySelector('dialog')?.close(); document.documentElement.classList.remove('pg-menu-is-open'); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petgraf-social-discovery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pg-logo-carousel'))customElements.define('pg-logo-carousel',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const {signal}=this.abort;
  const track=this.querySelector('[data-track]');if(!track)return;
  const slides=[...track.children],dots=[...this.querySelectorAll('[data-dot]')],prev=this.querySelector('[data-step="-1"]'),next=this.querySelector('[data-step="1"]');
  const index=()=>Math.round(track.scrollLeft/Math.max(1,track.clientWidth));
  const go=i=>{i=Math.max(0,Math.min(slides.length-1,i));const smooth=!matchMedia('(prefers-reduced-motion: reduce)').matches;track.scrollTo({left:i*track.clientWidth,behavior:smooth?'smooth':'auto'});};
  const sync=()=>{const i=index();dots.forEach((d,k)=>k===i?d.setAttribute('aria-current','true'):d.removeAttribute('aria-current'));if(prev)prev.disabled=i<=0;if(next)next.disabled=i>=slides.length-1;};
  let raf=0;track.addEventListener('scroll',()=>{cancelAnimationFrame(raf);raf=requestAnimationFrame(sync);},{passive:true,signal});
  dots.forEach((d,k)=>d.addEventListener('click',()=>go(k),{signal}));
  [prev,next].forEach(b=>b&&b.addEventListener('click',()=>go(index()+Number(b.dataset.step)),{signal}));
  track.addEventListener('keydown',e=>{if(e.target!==track)return;const map={ArrowLeft:-1,ArrowRight:1};if(e.key in map){e.preventDefault();go(index()+map[e.key]);}else if(e.key==='Home'||e.key==='End'){e.preventDefault();go(e.key==='Home'?0:slides.length-1);}},{signal});
  this.addEventListener('contextmenu',e=>{if(e.target.closest('.pg-social-track'))e.preventDefault();},{signal});
  track.addEventListener('dragstart',e=>e.preventDefault(),{signal});
  let drag=null;
  track.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'||e.button!==0||slides.length<2)return;drag={id:e.pointerId,x:e.clientX,left:track.scrollLeft,start:index(),moved:false};},{signal});
  window.addEventListener('pointermove',e=>{if(!drag||e.pointerId!==drag.id)return;const dx=e.clientX-drag.x;if(!drag.moved&&Math.abs(dx)<6)return;if(!drag.moved){drag.moved=true;track.dataset.dragging='';track.setPointerCapture?.(e.pointerId);}e.preventDefault();track.scrollLeft=drag.left-dx;},{signal});
  const end=e=>{if(!drag||e.pointerId!==drag.id)return;const d=drag;drag=null;if(!d.moved)return;delete track.dataset.dragging;const dx=e.clientX-d.x,th=track.clientWidth*.15;go(d.start+(dx<-th?1:dx>th?-1:0));};
  window.addEventListener('pointerup',end,{signal});window.addEventListener('pointercancel',end,{signal});
  addEventListener('resize',()=>sync(),{signal});sync();
 }
 disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-sobre-avaliacoes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciar(raiz) {
    if (raiz.dataset.pronto) return;
    raiz.dataset.pronto = '1';
    var cols = raiz.querySelector('[data-pgs-cols]');
    var trilho1 = raiz.querySelector('[data-pgs-track]');
    var cartoes = Array.prototype.slice.call(trilho1.children);
    var botao = raiz.querySelector('[data-pgs-pausa]');
    var largo = window.matchMedia('(min-width: 990px)');
    var reduzir = window.matchMedia('(prefers-reduced-motion: reduce)');
    var trilhos = [];
    var quadro = 0;
    var ultimo = 0;
    var visivel = !('IntersectionObserver' in window);
    var pausado = false;
    var fator = (parseFloat(raiz.dataset.pgsVel) || 100) / 100;
    var horizontal = raiz.dataset.pgsEixo === 'x';

    function montar() {
      var extra = cols.querySelector('[data-pgs-col2]');
      if (extra) extra.remove();
      cartoes.forEach(function (c) { trilho1.appendChild(c); });
      trilhos = [{ el: trilho1, y: 0, v: (horizontal ? 30 : 22) * fator }];
      if (largo.matches && !horizontal) {
        var col2 = document.createElement('div');
        col2.className = 'pgs-col';
        col2.setAttribute('data-pgs-col2', '');
        var trilho2 = document.createElement('ul');
        trilho2.className = 'pgs-track';
        cartoes.forEach(function (c, i) { if (i % 2) trilho2.appendChild(c); });
        col2.appendChild(trilho2);
        cols.appendChild(col2);
        trilhos.push({ el: trilho2, y: -110, v: 17 * fator });
      }
      raiz.classList.toggle('is-largo', largo.matches && !horizontal);
      atualizar();
    }

    function atualizar() {
      var anima = !reduzir.matches;
      raiz.classList.toggle('is-anim', anima);
      botao.hidden = !anima;
      cols.querySelectorAll('.pgs-col').forEach(function (c) {
        if (anima) c.removeAttribute('tabindex'); else c.setAttribute('tabindex', '0');
      });
      trilhos.forEach(function (t) {
        t.vao = parseFloat(horizontal ? getComputedStyle(t.el).columnGap : getComputedStyle(t.el).rowGap) || 20;
        if (!anima) t.y = 0;
        t.el.style.transform = anima ? (horizontal ? 'translate3d(' + t.y + 'px,0,0)' : 'translate3d(0,' + t.y + 'px,0)') : '';
      });
      rodar();
    }

    function rodar() {
      var deve = !reduzir.matches && visivel && !pausado && !document.hidden;
      if (deve && !quadro) { ultimo = 0; quadro = requestAnimationFrame(passo); }
      if (!deve && quadro) { cancelAnimationFrame(quadro); quadro = 0; }
    }

    function passo(agora) {
      var dt = ultimo ? Math.min(agora - ultimo, 50) / 1000 : 0;
      ultimo = agora;
      trilhos.forEach(function (t) {
        t.y -= t.v * dt;
        var primeiro = t.el.firstElementChild;
        if (primeiro) {
          var altura = (horizontal ? primeiro.offsetWidth : primeiro.offsetHeight) + t.vao;
          if (-t.y >= altura) { t.el.appendChild(primeiro); t.y += altura; }
        }
        t.el.style.transform = horizontal ? 'translate3d(' + t.y.toFixed(2) + 'px,0,0)' : 'translate3d(0,' + t.y.toFixed(2) + 'px,0)';
      });
      quadro = requestAnimationFrame(passo);
    }

    botao.addEventListener('click', function () {
      pausado = !pausado;
      botao.setAttribute('aria-pressed', String(pausado));
      botao.setAttribute('aria-label', pausado ? 'Continuar avaliações' : 'Pausar avaliações');
      rodar();
    });
    if (!visivel) {
      new IntersectionObserver(function (e) { visivel = e[0].isIntersecting; rodar(); }, { rootMargin: '120px 0px' }).observe(raiz);
    }
    document.addEventListener('visibilitychange', rodar);
    largo.addEventListener('change', montar);
    reduzir.addEventListener('change', atualizar);
    montar();
  }

  function todos() { document.querySelectorAll('[data-pgs-rv]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
  document.addEventListener('shopify:section:load', todos);
})();

  } catch(e) { console.error(e); }
})();
})();
